import { Drawer, DrawerProps } from 'antd'

import { useBreakpoint } from '@/hooks/useBreakpoint'

type Props = DrawerProps & {
  maxWidth: number | string
}

export const ResponsiveDrawer: React.FC<Props> = ({
  maxWidth,
  children,
  ...drawerProps
}) => {
  const isFullWidth = useBreakpoint('sm')

  return (
    <Drawer width={isFullWidth ? '100%' : maxWidth} {...drawerProps}>
      {children}
    </Drawer>
  )
}
